/*
 * Copyright © 2015-2022 Serenova, LLC. All rights reserved.
 */

/*
 * Select Messages
 *
 * This contains all the text for the Select component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  selectPlaceholder: {
    id: 'app.containers.Select.selectPlaceholder',
    defaultMessage: 'Select...',
  },
  noResultsText: {
    id: 'app.containers.Select.noResultsText',
    defaultMessage: 'No results found',
  },
});
